import { motion } from "framer-motion";
import { Package, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToSection } from "@/lib/lenis";

export const PersonalGoods = () => (
  <section className="py-16 lg:py-20 bg-cream-alt" data-testid="personal-goods-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-10">
      <Reveal>
        <div className="rounded-2xl border border-gold/25 bg-white shadow-sm p-8 sm:p-12 flex flex-col sm:flex-row items-start sm:items-center gap-8">
          <div className="h-14 w-14 rounded-2xl bg-gold/10 flex items-center justify-center shrink-0">
            <Package size={26} className="text-gold-muted" />
          </div>
          <div className="flex-1">
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl text-ink">
              Sending Goods Home to Family?
            </h2>
            <p className="mt-3 text-base text-ink-soft leading-relaxed max-w-2xl">
              Whether you are shipping a barrel, a care package, or personal effects back home to
              Jamaica or across the Caribbean, Ferguson's handles your shipment with the same care
              and compliance expertise we bring to our largest commercial clients. Get a quote
              today.
            </p>
            <motion.button
              whileTap={{ scale: 0.98 }}
              onClick={() => scrollToSection("#quote")}
              data-testid="personal-goods-quote-cta"
              className="group mt-6 bg-gold hover:bg-gold-hover text-[#0A140F] font-display font-semibold text-sm px-7 py-3 rounded-full flex items-center gap-2 transition-colors"
            >
              Get a Quote Today
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </motion.button>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
